// Adobe Typekit font loading
// Load font dynamically to avoid build issues with external CSS imports
if (typeof window !== 'undefined') {
  // Check if font is already loaded
  const existingLink = document.querySelector('link[href*="typekit.net"]');

  if (!existingLink) {
    const link = document.createElement('link');

    link.rel = 'stylesheet';
    link.href = 'https://use.typekit.net/kuw8vdx.css';
    link.crossOrigin = 'anonymous';

    // Add to head
    document.head.appendChild(link);

    // Optional: Add error handling
    link.onerror = () => {
      console.warn('Failed to load Adobe Typekit font');
    };
  }
}
